import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';

const MODULES = [
  { path: '/games',      emoji: '🎮', label: 'Games',      color: '#FF6B6B', bg: '#FFE5E5' },
  { path: '/creativity', emoji: '🎨', label: 'Draw',       color: '#FF9F43', bg: '#FFF3E0' },
  { path: '/stories',   emoji: '📚', label: 'Stories',    color: '#FECA57', bg: '#FFFDE7' },
  { path: '/learning',  emoji: '🔭', label: 'Learn',      color: '#26de81', bg: '#E8F5E9' },
  { path: '/music',     emoji: '🎵', label: 'Music',      color: '#45AAF2', bg: '#E3F2FD' },
  { path: '/cooking',   emoji: '🍳', label: 'Cooking',    color: '#A55EEA', bg: '#F3E5F5' },
  { path: '/diary',     emoji: '📖', label: 'Diary',      color: '#2BCBBA', bg: '#E0F7FA' },
  { path: '/focus',     emoji: '🧩', label: 'Focus',      color: '#FC5C65', bg: '#FCE4EC' }
];

const getLevelTitle = (level) => {
  if (level < 3) return 'Space Cadet';
  if (level < 5) return 'Star Explorer';
  if (level < 8) return 'Galaxy Hero';
  return 'Universe Master';
};

export default function HomeScreen() {
  const navigate = useNavigate();
  const { profile, loading } = useProfile();

  if (loading) {
    return (
      <div className="loading-screen">
        <div style={{ fontSize: '4rem' }}>🌌</div>
        <div className="spinner"></div>
        <p style={{ fontFamily: 'var(--font-title)', fontSize: '1.3rem', color: 'var(--purple)' }}>
          Loading your universe...
        </p>
      </div>
    );
  }

  const progressToNextLevel = profile ? (profile.total_points % 100) : 0;

  return (
    <div className="screen" style={{ background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ padding: '24px 20px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-title)', color: 'white', fontSize: '1.8rem', lineHeight: 1.2 }}>
            🌟 Kids Universe
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem', marginTop: 4 }}>
            Hello, {profile?.name || 'Explorer'}! 👋
          </p>
        </div>
        <button
          onClick={() => navigate('/profile')}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: '2px solid rgba(255,255,255,0.4)',
            borderRadius: '50%',
            width: 52,
            height: 52,
            fontSize: '1.5rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          🧑‍🚀
        </button>
      </div>

      {/* Profile Stats Card */}
      <div style={{ margin: '0 20px 20px', background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)', borderRadius: 20, padding: 16, border: '1px solid rgba(255,255,255,0.3)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>Level {profile?.level || 1}</div>
            <div style={{ color: 'white', fontFamily: 'var(--font-title)', fontSize: '1rem' }}>{getLevelTitle(profile?.level || 1)}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem' }}>Total Points</div>
            <div style={{ color: '#FECA57', fontFamily: 'var(--font-title)', fontSize: '1.4rem' }}>⭐ {profile?.total_points || 0}</div>
          </div>
        </div>
        {/* Progress bar */}
        <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 10, height: 8, overflow: 'hidden' }}>
          <div style={{ width: `${progressToNextLevel}%`, height: '100%', background: '#FECA57', borderRadius: 10, transition: 'width 0.5s' }} />
        </div>
        <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem', marginTop: 4 }}>
          {progressToNextLevel}/100 to next level
        </div>
      </div>

      {/* World / Module Grid */}
      <div style={{ flex: 1, background: 'var(--bg)', borderRadius: '28px 28px 0 0', padding: '24px 20px', minHeight: 500 }}>
        <h2 style={{ fontFamily: 'var(--font-title)', fontSize: '1.2rem', color: 'var(--dark)', marginBottom: 16, textAlign: 'center' }}>
          🌍 Your Universe
        </h2>

        <div className="grid-2" style={{ gap: 14 }}>
          {MODULES.map((mod) => (
            <button
              key={mod.path}
              className="module-btn"
              onClick={() => navigate(mod.path)}
              style={{ backgroundColor: mod.bg, color: mod.color }}
            >
              <span className="icon">{mod.emoji}</span>
              <span style={{ color: 'var(--dark)', fontSize: '0.9rem' }}>{mod.label}</span>
            </button>
          ))}
        </div>

        <div style={{ marginTop: 24, textAlign: 'center', color: 'var(--gray)', fontSize: '0.8rem' }}>
          Tap a world to start your adventure! 🚀
        </div>
      </div>
    </div>
  );
}
